if (!customElements.get('custom-variant-images')) {
  customElements.define(
    'custom-variant-images',

    class CustomVariantImages extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];


      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        console.log("Variant updated: ", selectedOptionValues);

        var colorValue;
        selectedOptionValues.forEach(optionId => {
          const input = document.querySelector(`input[data-option-value-id='${optionId}']`)
          if (input && input.name.toLowerCase().split("-")[0] === "color") {
            colorValue = input.dataset.valueHandle.trim();
          }
        });

        // Main gallery – hide on mobile only
        this.querySelectorAll(".product__media-item[data-variant-image]").forEach(el => {
          if (el.dataset.variantImageColor !== "") {
            el.classList.toggle("hidden-mobile", el.dataset.variantImageColor.trim() !== colorValue);
          }
        });

        // Thumbnail gallery - hide always
        this.querySelectorAll(".thumbnail-list__item[data-variant-image]").forEach(el => {
          if (el.dataset.variantImageColor !== "") {
            el.classList.toggle("hidden", el.dataset.variantImageColor.trim() !== colorValue);
          }
        });

        // Note: No need to update images in product modal, as the whole modal content 
        // is refreshed by default after each variuant change
      }
    }

  );
}
